"use client";

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import MainPage from './pages/MainPage';
import OAuthCallback from './pages/OAuthCallback';

import PrivateRoute from './PrivateRoute';
import { AuthProvider } from './AuthContext';

import './styles/animations.css';
import './styles/custom-scrollbar.css';

const App: React.FC = () => (
  <AuthProvider>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<OAuthCallback />} />
      <Route path="/" element={<PrivateRoute><MainPage /></PrivateRoute>} />
    </Routes>
  </AuthProvider>
);

export default App;
